import BoardOwnershipType from '@pkgs/shared/enums/BoardOwnershipType';
import BoardsSortMethod from '@pkgs/shared/enums/BoardsSortMethod';
import BoardUserRole from '@pkgs/shared/enums/BoardUserRole';
import boardUserRoleHasBoardUserRolePrivileges from '@pkgs/shared/helpers/boardUserRoleHasBoardUserRolePrivileges';

const canReorderBoard = (
	ownershipType: ValueOf<typeof BoardOwnershipType>,
	role: ValueOf<typeof BoardUserRole>,
	sortMethod: ValueOf<typeof BoardsSortMethod>,
): boolean => {
	// Only custom sort method allows reordering
	if (sortMethod !== BoardsSortMethod.CUSTOM) {
		return false;
	}

	if (ownershipType === BoardOwnershipType.TEAM) {
		return boardUserRoleHasBoardUserRolePrivileges(role, BoardUserRole.ADMIN);
	}

	if (ownershipType === BoardOwnershipType.USER) {
		return boardUserRoleHasBoardUserRolePrivileges(role, BoardUserRole.OWNER);
	}

	return false;
};

export default canReorderBoard;
